import { useRootSelector } from '../../../../../../store/hooks';
import { selectPageConfig } from '../../../../../../store/features/pageConfig';
import { ImageTag } from '../../../../../shared/ImageTag/ImageTag';
import { HTMLtoJSX } from '../../../../../../helpers';

import './PalmFooterCopyright.scss';

export function PalmFooterCopyright() {
  const {
    tenantConfig: { copyright },
  } = useRootSelector(selectPageConfig);

  return (
    <div className="c-palm-magazine-footer-copyright">
      <div className="container">
        <div className="c-palm-magazine-footer-copyright__inner">
          <div className="row">
            <div className="col-xs-12 col-md-5 col-lg-3">
              <ImageTag
                src="/images/Informa-Markets-Logo.avif"
                alt="Informa Market"
                lazy={false}
                imgixParams="h=55"
                className="c-palm-magazine-footer-copyright__logo"
              />
            </div>
            <div className="col-xs-12 col-md-7 col-lg-9 c-palm-magazine-footer-copyright__text">
              {HTMLtoJSX(copyright)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PalmFooterCopyright;
